<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Client Conveyance Assignment</h5>
  </div>
<div
  id="mainContent"
  class="container"
  *ngIf="showClientConveyanceAssignmentDetails"
>
  <div class="modal-body mt-2">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4">Branch<span class="text-danger">*</span> </label>
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs"
              id="branch"
              name="branch"
              [(ngModel)]="selectedBranch"
              (change)="onSelectBranch()"
            >
              <option value="">Select Branch</option>
              <option *ngFor="let branch of branchList" [value]="branch.id">
                {{ branch.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Client Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedClientStatus"
              (change)="onStatusSelect()"
            >
            <option value="">Select Status</option>
              <option value="1">Active</option>
              <option value="2">Closed</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4">Client<span class="text-danger">*</span> </label>
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs"
              id="client"
              name="client"
              [(ngModel)]="selectClientName"
              (change)="onSelectClientName()"
            >
              <option value="">Select Client</option>
              <option *ngFor="let client of clientNameList" [value]="client.id">
                {{ client.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Bill Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectBillingDate"
            >
              <option value="">Select Billing Date</option>
              <option
                *ngFor="let billingdate of billingDateList"
                [ngValue]="billingdate"
              >
                {{ billingdate.generatedDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <div class="col-sm-4">
            <button
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Details
            </button>
          </div>
          <div class="col-sm-5" *ngIf="showExportToExcelButton">
            <button
              (click)="exportToExcelClientAssignment()"
              class="btn btn-sm btn-block btn-outline-theme"
            >
              <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
            </button>
          </div>
        </div>
      </div>
    </div>
   </div>
   </div>

    <div class="container" id="mainContent" *ngIf="clientConveyanceAssignmentList != null && showClientConveyanceAssignmentDetails">
      <div class="row pt-3 justify-content-center text-center">
        <span class="bg-theme-title"
          >P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>
      <div class="row mt-3 justify-content-center text-center">
          <span class="bg-theme-title">Client Conveyance Summary</span>
      </div>
      <div class="row justify-content-center text-center">
          <span class="bg-theme-title">{{
            clientConveyanceAssignmentList.clientName
          }}</span>
      </div>
      <div class="row justify-content-center text-center">
          <span class="bg-theme-title"
            >Financial Year {{ selectedFinancialYear.name }}</span
          >
      </div>

      <div class="row mt-3">
        <div class="col-sm-6">
          <label class="col-form-label"
            ><b
              >Bill Date :
              {{
                clientConveyanceAssignmentList.billDate | date: "dd-MMM-yyyy"
              }}</b
            ></label
          >
        </div>
        <div class="col-sm-6" style="display: flex; justify-content: flex-end">
          <label class="col-form-label"
            ><b
              >Last Billed Date:
              {{
                lastBilledDate == undefined
                  ? ""
                  : (lastBilledDate.generatedDate | date: "dd-MMM-yyyy")
              }}</b
            ></label
          >
        </div>
      </div>

      <div class="row col-md-12">
        <table class="table table-bordered table-sm table-striped">
          <thead>
            <tr>
              <th>Assignment</th>
              <th>Diary Closing Date</th>
              <th>Period</th>
              <th>Billed Amount</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="
                let assignment of clientConveyanceAssignmentList.assignments;
                let clientIndex = index;
                let clientCount = count
              "
            >
              <ng-container
                *ngFor="
                  let closingDate of assignment.diaryClosingDates;
                  let closingDateIndex = index;
                  let closingDateCount = count
                "
              >
                <ng-container
                  *ngFor="
                    let period of closingDate.periods;
                    let periodIndex = index;
                    let periodCount = count
                  "
                >
                  <tr *ngIf="closingDateIndex == 0 && periodIndex == 0">
                    <td
                      [attr.rowspan]="
                        getRowSpanForClient(assignment) + closingDateCount + 2
                      "
                      style="color: #800000!important; cursor: pointer;text-decoration: underline;"
                      (click)="
                        getClientBilledConveyanceList(
                          clientConveyanceAssignmentList.clientId,
                          clientConveyanceAssignmentList.billingId,
                          assignment.assignmentId
                        )
                      "
                    >
                      {{ assignment.assignmentName }}
                    </td>
                    <td [attr.rowspan]="periodCount + 1">
                      {{
                        (closingDate.diaryClosigDate | date: "dd-MM-yyyy") ===
                        "11-11-1111"
                          ? "Not Closed"
                          : (closingDate.diaryClosigDate
                              | date: "dd-MM-yyyy") === "11-02-1950"
                          ? "Not Closed"
                          : (closingDate.diaryClosigDate | date: "dd-MM-yyyy")
                      }}
                    </td>
                    <td
                      (click)="
                        getClientMonthlyConveyanceList(
                          clientConveyanceAssignmentList.clientId,
                          closingDate.closingId,
                          clientConveyanceAssignmentList.billingId,
                          assignment.assignmentId,
                          period.month,
                          period.year
                        )
                      "
                      style="color: #800000!important; cursor: pointer;text-decoration: underline;"
                    >
                      {{ changeMonthNumberToName(period.month) }} -
                      {{ period.year }}
                    </td>
                    <td>{{ period.amount  | number: "1.2-2"}}</td>
                  </tr>
                  <tr *ngIf="closingDateIndex != 0 && periodIndex == 0">
                    <td [attr.rowspan]="periodCount + 1">
                      {{
                        (closingDate.diaryClosigDate | date: "dd-MM-yyyy") ===
                        "11-11-1111"
                          ? "Not Closed"
                          : (closingDate.diaryClosigDate
                              | date: "dd-MM-yyyy") === "11-02-1950"
                          ? "Not Closed"
                          : (closingDate.diaryClosigDate | date: "dd-MM-yyyy")
                      }}
                    </td>
                    <td
                      (click)="
                        getClientMonthlyConveyanceList(
                          clientConveyanceAssignmentList.clientId,
                          closingDate.closingId,
                          clientConveyanceAssignmentList.billingId,
                          assignment.assignmentId,
                          period.month,
                          period.year
                        )
                      "
                      style="color: #800000!important; cursor: pointer"
                    >
                      {{ changeMonthNumberToName(period.month) }} -
                      {{ period.year }}
                    </td>
                    <td>{{ period.amount  | number: "1.2-2"}}</td>
                  </tr>
                  <tr *ngIf="periodIndex != 0">
                    <td
                      (click)="
                        getClientMonthlyConveyanceList(
                          clientConveyanceAssignmentList.clientId,
                          closingDate.closingId,
                          clientConveyanceAssignmentList.billingId,
                          assignment.assignmentId,
                          period.month,
                          period.year
                        )
                      "
                      style="color: #800000!important; cursor: pointer"
                    >
                      {{ changeMonthNumberToName(period.month) }} -
                      {{ period.year }}
                    </td>
                    <td>{{ period.amount  | number: "1.2-2"}}</td>
                  </tr>
                  <tr
                    *ngIf="periodCount == periodIndex + 1"
                    style="background-color: #e1f4f7"
                  >
                    <td>Total</td>
                    <td>
                      {{ calculateBillingAmountByPeriod(closingDate.periods) | number: "1.2-2" }}
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      closingDateCount == closingDateIndex + 1 &&
                      periodCount == periodIndex + 1
                    "
                    style="background-color: #e1f4f7"
                  >
                    <td>Diary Total</td>
                    <td></td>
                    <td>
                      {{
                        calculateBillingAmountByDate(
                          assignment.diaryClosingDates
                        )
                      }}
                    </td>
                  </tr>

                  <tr
                    *ngIf="
                      closingDateCount == closingDateIndex + 1 &&
                      periodCount == periodIndex + 1
                    "
                    style="background-color: #e1f4f7"
                  >
                    <td>Travel Total</td>
                    <td></td>
                    <td>
                      {{ assignment.travellingAllowance }}
                    </td>
                  </tr>

                  <tr
                    *ngIf="
                      clientCount == clientIndex + 1 &&
                      closingDateCount == closingDateIndex + 1 &&
                      periodCount == periodIndex + 1
                    "
                    style="background-color: #e1f4f7"
                  >
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td>{{ allBillingAmountTotal  | number: "1.2-2"}}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

<!-- Client Billed Conveyance Report-->
<div
  class="container" id="mainContent"
  *ngIf="clientBilledConveyanceList != null && showBilledConveyanceDetails"
>
<div class="row justify-content-center text-center pt-3">
  <span class="bg-theme-title"
    >P G BHAGWAT LLP, Chartered Accountants
  </span>
</div>
<div class="row justify-content-center text-center ">
  <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
</div>
  <div class="row mt-2">
    <div class="col-md-5" (click)="goBack()">
      <i class="fa fa-arrow-circle-o-left fa-2x"></i>
    </div>
    <div class="col-md-5">
      <span class="bg-theme-title">Billed Conveyance Details</span>
    </div>
    <div class="col-md-2">
      <button
        (click)="exportToExcelClientBilledConveyance()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>
  </div>
  <div class=" mt-3">
    <div class="row">
      <div class="col-sm-6">
        <label class="col-form-label"
          ><b
            >Assignment : {{ clientBilledConveyanceList.assignment }}</b
          ></label
        >
      </div>
      <div class="col-sm-6" style="display: flex; justify-content: flex-end">
        <label class="col-form-label"
          ><b
            >Bill Date:
            {{ clientBilledConveyanceList.billDate | date: "dd-MMM-yyyy" }}</b
          ></label
        >
      </div>
    </div>

    <div class="row col-md-12">
      <table class="table table-bordered table-sm table-striped">
        <thead>
          <tr>
            <th>Diary Date</th>
            <th>Employee / Article Name</th>
            <th>Task</th>
            <th>Two Wheeler</th>
            <th>Four Wheeler</th>
            <th>Bus/Auto/Other</th>
            <th>Billed Conveyance</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let diaryDate of clientBilledConveyanceList.diaryDates;
              let diaryDateIndex = index;
              let diaryDateCount = count
            "
          >
            <ng-container
              *ngFor="
                let diaryDetail of diaryDate.diaryDetails;
                let diaryDetailIndex = index;
                let diaryDetailCount = count
              "
            >
              <tr *ngIf="diaryDetailIndex == 0">
                <td [attr.rowspan]="getRowSpanForDiaryDate(diaryDate)">
                  {{ diaryDate.diaryDate | date: "dd-MMM-yyyy" }}
                </td>
                <td>{{ diaryDetail.firstName }} {{ diaryDetail.lastName }}</td>
                <td>{{ diaryDetail.task }}</td>
                <td>{{ diaryDetail.twoWheeler }}</td>
                <td>{{ diaryDetail.fourWheeler }}</td>
                <td>{{ diaryDetail.busAuto }}</td>
                <td>{{ diaryDetail.billedConveyance |number: "1.2-2"}}</td>
              </tr>
              <tr *ngIf="diaryDetailIndex != 0">
                <td>{{ diaryDetail.firstName }} {{ diaryDetail.lastName }}</td>
                <td>{{ diaryDetail.task }}</td>
                <td>{{ diaryDetail.twoWheeler }}</td>
                <td>{{ diaryDetail.fourWheeler }}</td>
                <td>{{ diaryDetail.busAuto }}</td>
                <td>{{ diaryDetail.billedConveyance |number: "1.2-2"}}</td>
              </tr>
              <tr
                *ngIf="
                  diaryDateCount == diaryDateIndex + 1 &&
                  diaryDetailCount == diaryDetailIndex + 1
                "
                style="background-color: #e1f4f7"
              >
                <td>Total</td>
                <td></td>
                <td></td>
                <td>{{ totalTwoWheelerCount }}</td>
                <td>{{ totalFourWheelerCount }}</td>
                <td>{{ totalBusAutoCount }}</td>
                <td>{{ totalBilledConveyanceCount |number: "1.2-2"}}</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!--Client Monthly Conveyance Report-->
<div
  class="container" id="mainContent"
  *ngIf="clientMonthlyConveyanceList != null && showMonthlyConveyanceDetails"
>
<div class="row justify-content-center text-center pt-3">
  <span class="bg-theme-title"
    >P G BHAGWAT LLP, Chartered Accountants
  </span>
</div>
<div class="row justify-content-center text-center ">
  <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
</div>

  <div class="row mt-2">
    <div class="col-sm-5" (click)="goBack()">
      <i class="fa fa-arrow-circle-o-left fa-2x"></i>
    </div>
    <div class="col-sm-5">
      <span class="bg-theme-title">Monthly Conveyance Details</span>
    </div>
    <div class="col-sm-2">
      <button
        (click)="exportToExcelClientMonthlyConveyanceList()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-5"></div>
    <div class="col-sm-7">
      <span class="bg-theme-title"
        >Closing Date :
        {{
          clientMonthlyConveyanceList.closingDate | date: "dd-MMM-yyyy"
        }}</span
      >
    </div>
  </div>
  <div class="mt-3">
    <div class="row">
      <div class="col-sm-6">
        <label class="col-form-label"
          ><b
            >Assignment : {{ clientMonthlyConveyanceList.assignment }}</b
          ></label
        >
      </div>
      <div class="col-sm-6" style="display: flex; justify-content: flex-end">
        <label class="col-form-label"
          ><b
            >Period:
            {{
              changeMonthToNumberMonthlyConveyance(
                clientMonthlyConveyanceList.pMonth
              )
            }}-{{ clientMonthlyConveyanceList.pYear }}</b
          ></label
        >
      </div>
    </div>

    <div class="row col-md-12">
      <table class="table table-bordered table-sm table-striped">
        <thead>
          <tr>
            <th>Diary Date</th>
            <th>Employee / Article Name</th>
            <th>Task</th>
            <th>Mode</th>
            <th>Distance</th>
            <th>Rate</th>
            <th>Total Conveyance</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let diaryDate of clientMonthlyConveyanceList.diaryDates;
              let diaryDateIndex = index;
              let diaryDateCount = count
            "
          >
            <ng-container
              *ngFor="
                let diaryDetail of diaryDate.diaryDetails;
                let diaryDetailIndex = index;
                let diaryDetailCount = count
              "
            >
              <tr *ngIf="diaryDetailIndex == 0">
                <td [attr.rowspan]="getRowSpanForDiaryDate(diaryDate)">
                  {{ diaryDate.diaryDate | date: "dd-MM-yyyy" }}
                </td>
                <td>{{ diaryDetail.firstName }} {{ diaryDetail.lastName }}</td>
                <td>{{ diaryDetail.task }}</td>
                <td>{{ diaryDetail.mode }}</td>
                <td>{{ diaryDetail.distance }}</td>
                <td>{{ diaryDetail.rate }}</td>
                <td>{{ diaryDetail.totalConveyance |number: "1.2-2"}}</td>
              </tr>
              <tr *ngIf="diaryDetailIndex != 0">
                <td>{{ diaryDetail.firstName }} {{ diaryDetail.lastName }}</td>
                <td>{{ diaryDetail.task }}</td>
                <td>{{ diaryDetail.mode }}</td>
                <td>{{ diaryDetail.distance }}</td>
                <td>{{ diaryDetail.rate }}</td>
                <td>{{ diaryDetail.totalConveyance|number: "1.2-2" }}</td>
              </tr>
              <tr
                *ngIf="
                  diaryDateCount == diaryDateIndex + 1 &&
                  diaryDetailCount == diaryDetailIndex + 1
                "
                style="background-color: #e1f4f7"
              >
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ totalMonthlyConveyanceCount |number: "1.2-2"}}</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>